(function () {
  'use strict';

  function safeUrl(value, image) {
    if (typeof value !== 'string' || !value.trim()) return '';
    var url = value.trim();
    if (!image && /^\/(?!\/)/.test(url) && !/[\\\s]/.test(url)) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.protocol === 'https:' ? parsed.href : '';
    } catch (_) {
      return '';
    }
  }

  function imageSource(image) {
    return typeof image === 'string' ? safeUrl(image, true) : safeUrl(image && image.src, true);
  }

  function applyResponsiveImage(node, image) {
    var source = imageSource(image);
    if (!source) return false;
    if (image && typeof image === 'object' && Array.isArray(image.variants)) {
      var srcset = image.variants
        .map(function (variant) {
          var url = safeUrl(variant && variant.url, true);
          var width = Number.parseInt(variant && variant.width, 10);
          return url && width > 0 ? url + ' ' + width + 'w' : '';
        })
        .filter(Boolean)
        .join(', ');
      if (srcset) node.srcset = srcset;
    }
    node.src = source;
    return true;
  }

  function heading(section) {
    if (!section.heading) return null;
    var node = document.createElement('h2');
    node.className = 'homepage-licensed__heading';
    node.textContent = section.heading || '';
    return node;
  }

  function selectLicensedCategory(root, category) {
    var available = Array.from(root.querySelectorAll('[data-homepage-licensed-tab]')).filter(function (tab) {
      return !tab.hidden;
    });
    if (!available.some(function (tab) { return tab.getAttribute('data-homepage-licensed-tab') === category; })) {
      category = available.length ? available[0].getAttribute('data-homepage-licensed-tab') : '';
    }
    root._homepageLicensedCategory = category;
    root.querySelectorAll('[data-homepage-licensed-tab]').forEach(function (tab) {
      var selected = tab.getAttribute('data-homepage-licensed-tab') === category;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    root.querySelectorAll('[data-homepage-licensed-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-homepage-licensed-panel') !== category;
    });
  }

  function licensedCategory(card) {
    return card.category === 'pop-culture' ? 'pop-culture' : 'sports';
  }

  function renderLicensed(section, root) {
    if (!root._homepageFallbackLicensed) return null;
    var wrapper = root._homepageFallbackLicensed.cloneNode(true);
    var title = wrapper.querySelector('[data-homepage-licensed-heading-desktop]');
    if (title && section.heading) title.textContent = section.heading;
    var mobileTitle = wrapper.querySelector('[data-homepage-licensed-heading-mobile]');
    if (mobileTitle) mobileTitle.textContent = section.mobileHeading || 'Officially licensed';
    var fallbackImages = root._homepageFallbackImages || {};
    var grids = {
      sports: document.createDocumentFragment(),
      'pop-culture': document.createDocumentFragment(),
    };

    (Array.isArray(section.cards) ? section.cards : []).forEach(function (card) {
      if (!card) return;
      var category = licensedCategory(card);
      if (card.enabled === false) return;
      var href = safeUrl(card.url, false);
      if (!href) return;
      var link = document.createElement('a');
      link.className = 'homepage-licensed__card';
      link.href = href;
      link.setAttribute('data-homepage-licensed-card', card.id || '');
      link.setAttribute('aria-label', 'Shop ' + (card.label || card.id || 'collection'));
      var scale = Number(card.logoScale);
      scale = card.logoScale != null && Number.isFinite(scale) ? Math.min(300, Math.max(50, scale)) : category === 'pop-culture' ? 200 : 100;
      var mobileScale = Number(card.mobileLogoScale);
      mobileScale = card.mobileLogoScale != null && Number.isFinite(mobileScale) ? Math.min(300, Math.max(50, mobileScale)) : scale;
      link.style.setProperty('--homepage-logo-scale', scale / 100);
      link.style.setProperty('--homepage-logo-mobile-scale', mobileScale / 100);
      var image = document.createElement('img');
      image.alt = card.alt || card.label || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.sizes = '(max-width: 749px) ' + Math.ceil((category === 'pop-culture' ? 0.195 : 0.175) * mobileScale) + 'vw, ' + Math.ceil((category === 'pop-culture' ? 0.18 : 0.105) * scale) + 'vw';
      if (!applyResponsiveImage(image, card.image) && fallbackImages[card.id]) {
        image.src = fallbackImages[card.id];
      }
      link.appendChild(image);
      grids[category].appendChild(link);
    });
    ['sports', 'pop-culture'].forEach(function (category) {
      var tab = wrapper.querySelector('[data-homepage-licensed-tab="' + category + '"]');
      tab.hidden = !grids[category].childNodes.length;
      if (section.categoryLabels && section.categoryLabels[category]) {
        tab.textContent = section.categoryLabels[category];
      }
      wrapper.querySelector('[data-homepage-licensed-panel="' + category + '"]').replaceChildren(grids[category]);
    });
    return wrapper;
  }

  function renderImageGrid(section) {
    var carousel = section.type === 'collection-carousel';
    var wrapper = document.createElement('section');
    wrapper.className = 'homepage-builder__section' + (carousel ? ' homepage-builder__section--carousel' : '');
    var header = carousel ? document.createElement('div') : wrapper;
    if (carousel) {
      header.className = 'homepage-builder__carousel-header';
      wrapper.appendChild(header);
    }
    var title = heading(section);
    if (title) header.appendChild(title);
    var grid = document.createElement('div');
    grid.className = 'homepage-builder__grid' + (carousel ? ' homepage-builder__carousel' : '');
    if (carousel) {
      grid.id = 'homepage-carousel-' + section.id;
      grid.tabIndex = 0;
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', section.heading || 'Collections');
    }

    (Array.isArray(section.cards) ? section.cards : []).forEach(function (card) {
      if (!card || card.enabled === false) return;
      var href = safeUrl(card.url, false);
      if (!href || !imageSource(card.image)) return;
      var link = document.createElement('a');
      var shape = carousel ? 'tall' : ['square', 'portrait'].indexOf(card.aspectRatio) >= 0
        ? card.aspectRatio
        : 'landscape';
      var desktopSpan = [1, 2, 3, 4].indexOf(card.desktopSpan) >= 0 ? card.desktopSpan : 1;
      var tabletSpan = [1, 2].indexOf(card.tabletSpan) >= 0 ? card.tabletSpan : 1;
      link.className = 'homepage-builder__card homepage-builder__card--' + shape;
      link.href = href;
      link.setAttribute('aria-label', 'Shop ' + (card.label || card.alt || 'collection'));
      link.style.setProperty('--homepage-card-desktop-span', desktopSpan);
      link.style.setProperty('--homepage-card-tablet-span', tabletSpan);

      var media = document.createElement('span');
      media.className = 'homepage-builder__media';
      var image = document.createElement('img');
      image.alt = card.alt || card.label || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.sizes = carousel
        ? '(min-width: 990px) 20vw, (min-width: 750px) 33vw, 46vw'
        : desktopSpan === 4
          ? '100vw'
          : desktopSpan === 2
            ? '(min-width: 990px) 50vw, 100vw'
            : '(min-width: 990px) 25vw, (min-width: 750px) 50vw, 100vw';
      applyResponsiveImage(image, card.image);
      media.appendChild(image);
      link.appendChild(media);

      if (card.label) {
        var label = document.createElement('span');
        label.className = carousel ? 'homepage-builder__overlay' : 'homepage-builder__label';
        if (carousel) {
          var positions = ['top-left', 'top-center', 'top-right', 'center-left', 'center', 'center-right', 'bottom-left', 'bottom-center', 'bottom-right'];
          var position = positions.indexOf(card.overlayPosition) >= 0 ? card.overlayPosition : 'bottom-right';
          var axes = position === 'center' ? ['center', 'center'] : position.split('-');
          label.style.setProperty('--homepage-overlay-align', { top: 'start', center: 'center', bottom: 'end' }[axes[0]]);
          label.style.setProperty('--homepage-overlay-justify', { left: 'start', center: 'center', right: 'end' }[axes[1]]);
          label.style.setProperty('--homepage-overlay-text-align', axes[1]);
          label.style.setProperty('--homepage-overlay-writing-mode', card.overlayOrientation === 'vertical' ? 'vertical-rl' : 'horizontal-tb');
          [['overlayFontSize', '--homepage-overlay-font-size', 32], ['overlayMobileFontSize', '--homepage-overlay-mobile-font-size', 20]].forEach(function (setting) {
            var size = Number(card[setting[0]]);
            size = card[setting[0]] != null && card[setting[0]] !== '' && Number.isFinite(size) ? Math.min(72, Math.max(12, Math.round(size))) : setting[2];
            label.style.setProperty(setting[1], size + 'px');
          });
          var overlayText = document.createElement('span');
          overlayText.className = 'homepage-builder__overlay-text';
          overlayText.textContent = card.label;
          label.appendChild(overlayText);
        } else {
          label.textContent = card.label;
        }
        (carousel ? media : link).appendChild(label);
      }
      grid.appendChild(link);
    });
    wrapper.appendChild(grid);
    return wrapper;
  }

  function updateCarouselControls(root) {
    root.querySelectorAll('.homepage-builder__section--carousel').forEach(function (section) {
      var grid = section.querySelector('.homepage-builder__carousel');
    });
  }

  function fitCarouselHeadings(root) {
    root.querySelectorAll('.homepage-builder__carousel-header .homepage-licensed__heading').forEach(function (title) {
      title.style.removeProperty('font-size');
      var available = title.getBoundingClientRect().width - 3;
      if (available <= 0) return;
      var text = document.createRange();
      text.selectNodeContents(title);
      if (text.getBoundingClientRect().width <= available) return;
      var minimum = 18;
      var maximum = parseFloat(window.getComputedStyle(title).fontSize);
      // Measure the actual font against the room left by the arrow controls.
      for (var step = 0; step < 8; step += 1) {
        var size = (minimum + maximum) / 2;
        title.style.fontSize = size + 'px';
        if (text.getBoundingClientRect().width > available) maximum = size;
        else minimum = size;
      }
      title.style.fontSize = (Math.floor(minimum * 10) / 10) + 'px';
    });
  }

  function render(root, payload) {
    if (!payload || payload.published !== true || !Array.isArray(payload.sections)) return;
    var content = root.querySelector('[data-homepage-builder-content]');
    if (!content) return;
    var fragment = document.createDocumentFragment();
    var hasImageGrid = false;
    payload.sections.forEach(function (section) {
      if (!section || section.enabled === false) return;
      if (section.type === 'licensed-collections') {
        var licensed = renderLicensed(section, root);
        if (licensed) fragment.appendChild(licensed);
      } else if (section.type === 'image-grid' || section.type === 'collection-carousel') {
        if (section.type === 'image-grid') hasImageGrid = true;
        fragment.appendChild(renderImageGrid(section));
      }
    });
    if (!hasImageGrid && root._homepageFallbackFeatured) {
      fragment.appendChild(root._homepageFallbackFeatured.cloneNode(true));
    }
    if (!fragment.childNodes.length) {
      root.hidden = true;
      return;
    }
    content.replaceChildren(fragment);
    root.querySelectorAll('.homepage-builder__carousel').forEach(function (grid) {
      grid.addEventListener('scroll', function () { updateCarouselControls(root); }, { passive: true });
    });
    window.requestAnimationFrame(function () {
      updateCarouselControls(root);
      fitCarouselHeadings(root);
      if (document.fonts) document.fonts.ready.then(function () { fitCarouselHeadings(root); });
    });
    selectLicensedCategory(root, root._homepageLicensedCategory || 'sports');
  }

  function initialize(root) {
    window.addEventListener('resize', function () {
      updateCarouselControls(root);
      fitCarouselHeadings(root);
    });
    root._homepageFallbackImages = {};
    var licensed = root.querySelector('[data-homepage-licensed-section]');
    root._homepageFallbackLicensed = licensed ? licensed.cloneNode(true) : null;
    root._homepageLicensedCategory = 'sports';
    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-homepage-licensed-tab]');
      if (tab && root.contains(tab)) {
        selectLicensedCategory(root, tab.getAttribute('data-homepage-licensed-tab'));
      }
    });
    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-homepage-licensed-tab]');
      if (!tab || !root.contains(tab)) return;
      var tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[data-homepage-licensed-tab]')).filter(function (item) {
        return !item.hidden;
      });
      var index = tabs.indexOf(tab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else return;
      event.preventDefault();
      selectLicensedCategory(root, tabs[index].getAttribute('data-homepage-licensed-tab'));
      tabs[index].focus();
    });
    var featured = root.querySelector('[data-homepage-builder-fallback-featured]');
    root._homepageFallbackFeatured = featured ? featured.cloneNode(true) : null;
    root.querySelectorAll('[data-homepage-licensed-card]').forEach(function (node) {
      var image = node.querySelector('img');
      if (image) root._homepageFallbackImages[node.getAttribute('data-homepage-licensed-card')] = image.src;
    });
    var endpoint = root.getAttribute('data-endpoint');
    if (!endpoint) return;
    fetch(endpoint, { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Homepage content unavailable');
        return response.json();
      })
      .then(function (payload) {
        render(root, payload);
      })
      .catch(function () {
        /* Keep the complete local fallback visible if Artomator is unavailable. */
      });
  }

  document.querySelectorAll('[data-homepage-licensed]').forEach(initialize);
})();
